'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$19() {
  this.bgh = null;
  this.bgf = null;
  this.bgg = false;
  this.bgd = null;
  this.bge = false;
  this.bgi = false;
  this.bgj = false;
  this.bgh = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$19 as $c_Lpresto_PrestoRouter$$anon$19 };
$p = $c_Lpresto_PrestoRouter$$anon$19.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$19;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$19() {
}
export { $h_Lpresto_PrestoRouter$$anon$19 as $h_Lpresto_PrestoRouter$$anon$19 };
$h_Lpresto_PrestoRouter$$anon$19.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bgh;
});
$p.t = (function() {
  if ((!this.bgg)) {
    this.bgf = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bgg = true;
  }
  return this.bgf;
});
$p.ag = (function() {
  if ((!this.bge)) {
    this.bgd = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bge = true;
  }
  return this.bgd;
});
$p.v = (function() {
  if ((!this.bgj)) {
    this.bgi = false;
    this.bgj = true;
  }
  return this.bgi;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$19 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$19, "presto.PrestoRouter$$anon$19", ({
  NR: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$19 as $d_Lpresto_PrestoRouter$$anon$19 };
//# sourceMappingURL=presto.-Presto-Router$$anon$19.js.map
